<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-dialog class="media_dialog" :md-active.sync="showDialog">
        <md-dialog-title>Add File</md-dialog-title>
        <template>
          <Upload
            @removeImage="removeImage"
            @uploadImage="addMedia"
            directory="Media Library"
            :media="media.url"
          />
          <md-field>
            <label>Add Tags</label>
            <md-chips v-model="media.tags"></md-chips>
          </md-field>
          <div class="helper-text">Press Enter in order to add a tag</div>
        </template>

        <md-dialog-actions>
          <md-button class="md-primary" @click="submit">Submit</md-button>
          <md-button class="md-primary" @click="showDialog = false"
            >Close</md-button
          >
        </md-dialog-actions>
      </md-dialog>
      <md-card>
        <md-card-content>
          <md-table
            md-fixed-header
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="medias">Per page</label>
                <md-select v-model="pagination.perPage" name="medias">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                    >{{ item }}</md-option
                  >
                </md-select>
              </md-field>

              <md-button
                class="md-primary md-round md-small"
                @click="showDialog = true"
                >Add a new media</md-button
              >

              <md-field>
                <md-input
                  type="search"
                  class="mb-3"
                  clearable
                  style="width: 200px"
                  placeholder="Search records"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-tooltip
                v-if="item.uploadedBy != currentUser && item.private"
                md-direction="top"
                >You don't have access to {{ item.uploadedBy }}'s content due to
                privacy turned on</md-tooltip
              >
              <md-table-cell md-label="Icon">
                <md-button
                  class="md-just-icon md-warning md-simple"
                  @click.native="openLink(item.url)"
                  :disabled="item.uploadedBy !== currentUser && item.private"
                >
                  <md-icon>image</md-icon>
                </md-button>
              </md-table-cell>
              <md-table-cell md-label="Name" md-sort-by="name">{{
                item.name
              }}</md-table-cell>
              <md-table-cell md-label="Size" md-sort-by="size">{{
                convertSize(item.size)
              }}</md-table-cell>
              <md-table-cell md-label="Date" md-sort-by="date">{{
                item.date | format_date
              }}</md-table-cell>
              <md-table-cell md-label="Type" md-sort-by="type">{{
                item.type
              }}</md-table-cell>

              <md-table-cell md-label="Tags" md-sort-by="tags">
                <!-- <md-chips v-model="item.tags"></md-chips> -->
                <md-chips v-model="item.tags" md-static></md-chips>
              </md-table-cell>
              <md-table-cell md-label="Uploaded By" md-sort-by="uploadedBy">{{
                item.uploadedBy
              }}</md-table-cell>

              <md-table-cell
                v-if="item.uploadedBy == currentUser"
                md-label="Private"
              >
                <md-switch
                  @change="updatePrivacy(item)"
                  v-model="item.private"
                  :value="true"
                >
                  <span>{{ item.private ? "Yes" : "No" }}</span>
                </md-switch>
              </md-table-cell>

              <md-table-cell v-else md-label="Private">
                <span>{{ item.private ? "Yes" : "No" }}</span>
              </md-table-cell>

              <md-table-cell md-label="Delete">
                <md-button
                  class="md-just-icon md-danger md-simple"
                  @click.native="handleDelete(item)"
                  :disabled="item.uploadedBy !== currentUser && item.private"
                >
                  <md-icon style="color: rgb(31, 71, 154) !important"
                    >close</md-icon
                  >
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import Fuse from "fuse.js";
import { db, auth } from "@/config/firebaseInit";
import Swal from "sweetalert2";
import router from "@/router";
import Upload from "@/components/Inputs/Upload.vue";

export default {
  components: {
    Pagination,
    Upload
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentSort: "name",
      currentSortOrder: "asc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      footerTable: [
        "media",
        "Description",
        "Last Signal",
        "URL",
        "Reports",
        "Edit",
        "Delete"
      ],
      searchQuery: "",
      propsToSearch: ["description", "last_signal", "slug"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      currentUser: null,
      showDialog: false,
      media: {
        url: null,
        name: null,
        uploadedBy: null,
        size: null,
        date: null,
        usage_count: null,
        private: null,
        tags: []
      }
    };
  },
  firestore() {
    return {
      tableData: db.collection("media_library")
    };
  },
  created() {
    this.currentUser = auth.currentUser.displayName;
  },
  methods: {
    removeImage() {
      this.media.url = null;
    },
    openLink(slug) {
      window.open(slug, "_blank");
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    convertSize(size) {
      if (size > 0 && size <= 999999) {
        return parseFloat(size / 1000).toFixed(2) + " KB";
      } else {
        return parseFloat(size / 1000000).toFixed(2) + " MB";
      }
    },
    addMedia(media) {
      this.media = Object.assign(this.media, media);
    },

    updatePrivacy(item) {
      db.collection("media_library")
        .doc(item.id)
        .update({ private: item.private });
    },

    submit() {
      let ref = db.collection("media_library").doc();
      this.media.uploadedBy = this.currentUser;
      ref
        .set(this.media)
        .then(() => {
          this.media = {
            url: null,
            name: null,
            size: null,
            date: null,
            usage_count: null,
            private: null,
            tags: []
          };
        })
        .then(() => {
          return Swal.fire(
            "Success",
            "Your file has been uploaded!",
            "success"
          );
        })
        .catch(err => {
          return Swal.fire(
            "Error",
            "Your file couldn't be uploaded, Try again later",
            "warning"
          );
        });
    },
    showImage(item) {
      let id = item.id;
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to undo this",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DELETE",
        cancelButtonText: "CANCEL"
      }).then(result => {
        if (result.value) {
          return db
            .collection("media_library")
            .doc(item.id)
            .delete()
            .then(() => {
              Swal.fire("Deleted!", "The page has been deleted.", "success");
            });
        }
      });
    }
  },

  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["name", "tags"],
      threshold: 0.3
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.media_dialog {
  width: 800px;
  overflow-y: auto;
  height: 600px;
}
</style>
